<script setup lang="ts">
  const props = defineProps({
    maxWidth: {
      type: Number,
      default: 600
    },
    modelValue: {
      type: Boolean,
      required: true
    }
  })

  const emit = defineEmits(['clickedOutside', 'update:modelValue'])

  function emitClickedOutside() {
    emit('clickedOutside')
  }

  function updateModelValue(value: boolean) {
    emit('update:modelValue', value)
  }
</script>

<template>
  <v-dialog
    :model-value="props.modelValue"
    :max-width="props.maxWidth"
    @update:model-value="updateModelValue"
    @click:outside="emitClickedOutside"
  >
    <v-card class="pa-3">
      <v-card-title class="px-0 mx-4 my-2 py-0">
        <slot name="title"></slot>
      </v-card-title>
      <v-card-text class="pl-4">
        <slot></slot>
      </v-card-text>
      <v-card-actions class="justify-space-between pa-0 mx-2">
        <div class="d-flex">
          <slot name="additional-actions"></slot>
        </div>
        <div class="d-flex">
          <slot name="actions"></slot>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped></style>
